import React from 'react';
import styled from 'styled-components';
import { History, ChevronRight } from 'lucide-react';
import colors from 'theme/colors';
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent';
import { Card, Delta, Muted, Section } from '../parts';
import { STATUS_LABELS, formatDate } from '../labels';

export default function HistoryTab({ analyses, selectedId, onSelect }) {
    const completed = analyses.filter(item => item.status === 'completed');

    return (
        <Section icon={History} title='Suas análises' subtitle='Uma por mês: acompanhe como cada nota evolui'>
            <Card style={{ padding: 0 }}>
                {analyses.map(item => {
                    const olderCompleted = completed.find(other => other.completed_at < item.completed_at);
                    const clickable = item.status === 'completed';

                    return (
                        <Row
                            key={item.id}
                            type='button'
                            disabled={!clickable}
                            $selected={item.id === selectedId}
                            onClick={() => clickable && onSelect(item.id)}
                        >
                            <div>
                                <RowTitle>{formatDate(item.completed_at || item.rejected_at || item.created_at)}</RowTitle>
                                <Muted>
                                    @{item.instagram_handle} · {STATUS_LABELS[item.status]}
                                    {item.status === 'rejected' && item.rejection_reason && ` — ${item.rejection_reason}`}
                                </Muted>
                            </div>
                            {clickable && (
                                <RowScore>
                                    <Delta current={item.overall_score} previous={olderCompleted?.overall_score} />
                                    <strong>{item.overall_score}</strong>
                                    <ChevronRight size={16} />
                                </RowScore>
                            )}
                        </Row>
                    );
                })}
            </Card>
        </Section>
    );
}

const Row = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 18px;
    border: none;
    background: ${({ $selected }) => ($selected ? panelAccentAlpha(colors.secondaryPurple, '0D') : 'transparent')};
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:disabled {
        cursor: default;
    }

    &:not(:disabled):hover {
        background: ${colors.neutralBackground};
    }

    & + & {
        border-top: 1px solid ${colors.neutralDark};
    }
`;

const RowTitle = styled.p`
    margin: 0 0 2px;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.nightDark};
`;

const RowScore = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: ${colors.nightLight};

    strong {
        font-size: 20px;
        color: ${panelAccent(colors.secondaryPurple)};
    }
`;
